// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { AppNotificationsProvider } from './context/AppNotificationsContext';
import ProtectedRoute from './routes/ProtectedRoute';
import MainLayout from './layouts/MainLayout';

// Auth Pages
import Login from './pages/auth/Login';
import Unauthorized from './pages/Unauthorized';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import SetPassword from './pages/auth/SetPassword';

// Main Pages
import Dashboard from './pages/Dashboard';
import ComingSoon from './pages/common/ComingSoon';

// Finance Pages
import Contracts from './pages/finance/Contracts';
import Expenses from './pages/finance/Expenses';

// Sales Pages
import Leads from './pages/sales/Leads';
import NewLead from './pages/sales/NewLead';
import LeadDetail from './pages/sales/LeadDetail';
import Commissions from './pages/sales/Commissions';

// HR Pages
import Payroll from './pages/hr/Payroll';
import Employees from './pages/hr/Employees';
import EmployeeProfile from './pages/hr/EmployeeProfile';
import Attendance from './pages/hr/Attendance';
import Leave from './pages/hr/Leave';
import Assets from './pages/hr/Assets';
import BankAccounts from './pages/finance/BankAccounts';
import BankAccountDetail from './pages/finance/BankAccountDetail';
import Reports from './pages/reports/Reports';
import ProfitLoss from './pages/reports/ProfitLoss';
import CashFlow from './pages/reports/CashFlow';
import Receivables from './pages/reports/Receivables';
import Performance from './pages/hr/Performance';
import PerformanceDetail from './pages/hr/PerformanceDetail';
import Offboarding from './pages/hr/Offboarding';
import OffboardingDetail from './pages/hr/OffboardingDetail';
import Notifications from './pages/Notifications';
import ContractDetail from './pages/finance/ContractDetail';
import Invoices from './pages/finance/Invoices';
import MeetingLog from './pages/sales/MeetingLog';
import Schedules from './pages/hr/Schedules';
import Onboarding from './pages/hr/Onboarding';
import Departments from './pages/departments/Departments';

// Employee Pages
import SelfService from './pages/employee/SelfService';

// Admin Pages
import AuditLogs from './pages/admin/AuditLogs';
import Settings from './pages/admin/Settings';
import PayrollDetail from './pages/hr/PayrollDetail';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
      <AppNotificationsProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/set-password" element={<SetPassword />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Dashboard />} />

              {/* Sales & Leads */}
              <Route path="sales" element={<Leads />} />
              <Route path="sales/new" element={<NewLead />} />
              <Route path="sales/leads/:id" element={<LeadDetail />} />
              <Route path="commissions" element={<Commissions />} />
              <Route path="meetings" element={<MeetingLog />} />

              {/* Finance */}
              <Route path="contracts" element={<Contracts />} />
              <Route path="contracts/:contractId" element={<ContractDetail />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="payroll/:id" element={<PayrollDetail />} />
              <Route path="invoices" element={<Invoices />} />

              {/* HR & Management */}
              <Route path="employees" element={<Employees />} />
              <Route path="employees/:employeeId" element={<EmployeeProfile />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route path="onboarding/:employeeId" element={<Onboarding />} />
              <Route path="departments" element={<Departments />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="leave" element={<Leave />} />
              <Route path="assets" element={<Assets />} />
              <Route path="bank-accounts" element={<BankAccounts />} />
              <Route path="bank-accounts/:accountId" element={<BankAccountDetail />} />
              <Route path="performance" element={<Performance />} />
              <Route path="performance/:reviewId" element={<PerformanceDetail />} />
              <Route path="offboarding" element={<Offboarding />} />
              <Route path="offboarding/:id" element={<OffboardingDetail />} />
              <Route path="schedules" element={<Schedules />} />
              <Route path="self-service" element={<SelfService />} />
              <Route path="notifications" element={<Notifications />} />

              {/* System Admin */}
              <Route path="audit-logs" element={<AuditLogs />} />
              <Route path="reports" element={<Reports />} />
              <Route path="reports/profit-loss" element={<ProfitLoss />} />
              <Route path="reports/cash-flow" element={<CashFlow />} />
              <Route path="reports/receivables" element={<Receivables />} />
              </Route>
            <Route element={<ProtectedRoute allowedRoles={['super_admin', 'hr_manager']} />}>
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      </AppNotificationsProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;